<template>
  <div>
    <div class="fixed top-full transform -translate-y-full right-0 z-30 max-w-full md:max-w-1/3 lg:max-w-1/4 bg-white rounded-lg p-6 shadow-gray flex flex-col justify-around">
      <div class="flex items-center">
        <div class="h-4 w-4 border border-black bg-teal-600 mr-2" />
        <span>Création</span>
      </div>
      <div class="flex items-center">
        <div class="h-4 w-4 border border-black bg-indigo-600 mr-2" />
        <span>Modification</span>
      </div>
      <div class="flex items-center">
        <div class="h-4 w-4 border border-black bg-pink-600 mr-2" />
        <span>Suppression</span>
      </div>
    </div>

    <action-button
      @clickAction="getUser"
      icon="refresh"
      libelle="Rafraîchir"
      border-color="transparent"
      bg-color="bg-indigo-600"
      icon-color="text-white"
      text-color="text-white"
    />



    <h1>Historique</h1>

    <h2 v-if="user">
      {{ user.firstname }} {{ user.lastname }}

      <router-link :to="`/form/neopass/${user.id}`">
        <action-button
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-200"
          icon-color="text-indigo-600"
          icon="file"
          libelle="Accéder au carnet"
          :enable-action="false"
        />
      </router-link>
    </h2>

    <list-grid
      v-if="user"
      :list-items="sortedAudits"
      is-accordion-items
    >
      <template #header>
        <div class="col-span-1 ml-2">
          Date
        </div>
        <div class="col-span-2">
          Auteur
        </div>
        <div class="col-span-3">
          Page
        </div>
        <div class="col-span-3">
          Type
        </div>
        <div class="col-span-3 mr-2">
          Action
        </div>
      </template>
      <template
        #accordionDescription="{ item, num }"
      >
        <div class="col-span-1 ml-2">
          {{ new Date(item.created_at).toLocaleDateString() }}<br>
          {{ new Date(item.created_at).toLocaleTimeString() }}
        </div>
        <div class="col-span-2">
          {{ authorType(item.user) }}<br>
          {{ item.user.firstname }} {{ item.user.lastname }}
        </div>
        <div class="col-span-3">
          {{ auditPage(item) }}
        </div>
        <div class="col-span-3">
          {{ auditType(item) }}
        </div>
        <div
          class="col-span-3 mr-2"
          :class="`text-${auditColor(item)}`"
        >
          {{ auditAction(item) }}
        </div>
      </template>
      <template #accordionContent="{ item, num }">
        <div v-if="isDataAudit(item)">
          <InformationsGenerales
            v-if="isIGPage(item)"
            :form="compareAudits(oldData(item), newData(item))"
          />
          <div v-else>
            La visualisation de la modification des données de cette page arrive bientôt.
          </div>
        </div>
        <div v-else-if="isEvalAudit(item)">
          <ReferentielMulti2
            v-if="isRefMulti2Eval(item)"
            :form="evalData(item)"
          />
        </div>
        <div v-else>
          La visualisation de la modification des données de cette page arrive bientôt.
        </div>
      </template>
    </list-grid>

    <div
      v-if="!user"
      class="w-full min-h-halfscreen flex justify-center items-center"
    >
      <span class="p-7 border-t-2 border-r-2 rounded-full animate-spin border-indigo-600" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ListGrid from '../../components/AccordionTable/ListGrid.vue';
import compareAudits from './compareAuditsb';
import Constants from '../../constants';
import InformationsGenerales from './formulaires/baseForms/InformationsGenerales.vue';
import ReferentielMulti2 from './formulaires/baseForms/ReferentielMulti2.vue';
import ActionButton from '../../components/ActionButton.vue';


export default {
  name: 'UserHistory',
  components: {ReferentielMulti2, InformationsGenerales, ListGrid, ActionButton },
  data() {
    return {
      constants: Constants,
      user: null,
    };
  },
  methods: {
    compareAudits,

    isIGPage(audit) {
      return audit.page?.name === this.constants.PAGE_NEOPASS_FORM_INFORMATIONS_GENERALES;
    },

    isRefMulti2Eval(audit) {
      return audit?.template?.type === this.constants.TEMPLATE_TYPES.multi2;
    },

    async getUser() {
      try {
        const { data: user } = await axios.get(
          `/api/user-histories/${this.$route.params.user}`
        );
        this.user = user;
      } catch (e) {
        console.log(e);
      }
    },

    authorType(author) {
      const manager = this.user.managers.find((manager) => {
        return manager.id === author.id;
      });

      return manager?.manager_user?.roles[0]?.name ?? 'Administrateur';
    },

    auditPage(audit) {
      if (audit.page) {
        return audit.page.display_name;
      }

      if (audit.template?.page) {
        return audit.template.page.display_name;
      }

      if (this.hasData(audit)) {
        return this.oldData(audit)?.name_temp ?? this.newData(audit)?.name_temp;
      }

      if (audit.auditable_type === 'App\\Models\\User') {
        return 'Synchronisation automatique';
      }
      return 'Inconnu : ' + audit.url;
    },

    auditType(audit) {
      if (audit.auditable_type === 'App\\Models\\User') {
        return 'Utilisateur';
      }
      if (audit.auditable_type === 'App\\Models\\Data') {
        return 'Données';
      }
      if (audit.auditable_type === 'App\\Models\\Evaluation') {
        return 'Évaluation';
      }
    },

    isDataAudit(audit) {
      return audit.auditable_type === 'App\\Models\\Data';
    },

    isEvalAudit(audit) {
      return audit.auditable_type === 'App\\Models\\Evaluation';
    },

    auditAction(audit) {
      switch (audit.event) {
      case 'created':
        return 'Création';
      case 'updated':
        return 'Modification';
      case 'deleted':
        return 'Suppression';
      case 'closed':
        return 'Clôture';
      default:
        return 'Inconnu';
      }
    },

    auditColor(audit) {
      switch (audit.event) {
      case 'created':
        return 'teal-600';
      case 'updated':
      case 'closed':
        return 'indigo-600';
      case 'deleted':
        return 'pink-600';
      default:
        return 'Inconnu';
      }
    },

    /**
     * @param {string} audit
     * @return {Object|null}
     */
    oldData(audit) {
      try {
        return JSON.parse(audit.old_values.data) ?? null;
      } catch {
        return null;
      }
    },

    /**
     * @param {string} audit
     * @return {Object|null}
     */
    newData(audit) {
      try {
        return JSON.parse(audit.new_values.data) ?? null;
      } catch {
        return null;
      }
    },

    hasData(audit) {
      return (
        Object.hasOwn(audit.old_values, 'data') &&
        Object.hasOwn(audit.new_values, 'data')
      );
    },

    hasNewData(audit) {
      return Object.hasOwn(audit.new_values, 'data');
    },

    evalData(audit) {
      let old = this.oldData(audit);
      let new_ = this.newData(audit);

      return this.compareAudits(old ?? {}, new_ ?? {});
    }
  },
  mounted() {
    this.getUser();
  },
  computed: {
    userAudits() {
      return this.user?.audits ?? [];
    },
    dataAudits() {
      return (
        this.user?.neopass?.datas?.flatMap((data) => {
          const page = data.page;
          return data.audits.map((audit) => {
            audit.page = page;
            return audit;
          });
        }) ?? []
      );
    },
    evalAudits() {
      return (
        this.user?.neopass?.evaluations?.flatMap(
          (evaluation) => {
            let audits = evaluation.audits;
            for (let i = 0; i < audits.length; i++) {
              let audit = audits[i];
              audit.template = evaluation.template;
            }
            return audits;
          }
        ) ?? []
      );
    },
    audits() {
      return [
        ...this.userAudits,
        ...this.dataAudits,
        ...this.evalAudits,
      ].filter((audit) => {
        for (const [key, value] of Object.entries(audit.new_values)) {
          if (value === null && audit.old_values[key] === null) {
            return false;
          }
          return true;
        }
      });
    },

    sortedAudits() {
      return [...this.audits].sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();

        if (dateA < dateB) {
          return 1;
        }

        if (dateB < dateA) {
          return -1;
        }

        return 0;
      });
    }
  },
};
</script>